import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";

const MOUQABALA_BASE_URL = "muqabala";

export const apiGetMouqabala = (
  page: number = 1,
  limit: number = 6,
  category: any = ""
): Promise<AxiosResponse<any, any>> => {
  return axios.get(
    MOUQABALA_BASE_URL +
      "/appointment-requests?page=" +
      page +
      "&limit=" +
      limit
  );
};

export const apiGetCreneauMouqabala = (data: {
  selected_date: string;
}): Promise<AxiosResponse<any, any>> => {
  const formatDate = new Date(
    parseInt(data.selected_date.split("/")[2]),
    parseInt(data.selected_date.split("/")[1]) - 1,
    parseInt(data.selected_date.split("/")[0])
  ).toISOString();
  console.log({ formatDate });
  return axios.get(
    MOUQABALA_BASE_URL + "/appointment-slots/available?date=" + formatDate
  );
};

export const apiSendCreneauMouqabala = (data: {
  id_creneau: any;
}): Promise<AxiosResponse<any, any>> => {
  return axios.post(MOUQABALA_BASE_URL + "/reservation-slots", {
    appointmentSlotId: data.id_creneau,
  });
};

export const apiAskMouqabala = (data: {
  id_receiver: any;
  conversation_id: any;
}): Promise<AxiosResponse<any, any>> => {
  return axios.post(MOUQABALA_BASE_URL + "/appointment-requests", {
    conversationId: data.conversation_id,
    receiverId: data.id_receiver,
  });
};

export const apiCheckExistingMouqabala = (
  data: string
): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    MOUQABALA_BASE_URL + "/appointment-requests/verify-appointment",
    {
      conversationId: data,
    }
  );
};

export const apiMouqabalaLink = (
  data: any
): Promise<AxiosResponse<any, any>> => {
  return axios.get(
    MOUQABALA_BASE_URL + "/appointment-requests/" + data + "/link"
  );
};

export const apiMouqabalaStripe = (data: {
  appointmentRequestId: string;
  appointmentSlotId: string;
}): Promise<AxiosResponse<any, any>> => {
  return axios.post(MOUQABALA_BASE_URL + "/appointment-payments", {
    appointmentRequestId: data.appointmentRequestId,
    appointmentSlotId: data.appointmentSlotId,
    method: "stripe",
  });
};

export const apiMouqabalaPaypal = (data: {
  appointmentRequestId: string;
  appointmentSlotId: string;
}): Promise<AxiosResponse<any, any>> => {
  return axios.post(MOUQABALA_BASE_URL + "/appointment-payments", {
    appointmentRequestId: data.appointmentRequestId,
    appointmentSlotId: data.appointmentSlotId,
    method: "paypal",
  });
};

export const apiMouqabalaPaypalAprrove = (data: {
  appointmentRequestId: string;
  appointmentSlotId: string;
  orderId: string;
}): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    MOUQABALA_BASE_URL +
      `/appointment-payments/${data.appointmentRequestId}/paypal-capture/${data.orderId}`,
    {
      appointmentSlotId: data.appointmentSlotId,
    }
  );
};

export const apiMouqabalaCancel = (data: {
  appointmentRequestId: string;
  appointmentSlotId?: string;
  reason?: string;
}): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    MOUQABALA_BASE_URL +
      "/appointment-requests/" +
      data.appointmentRequestId +
      "/report-or-cancel",
    {
      appointmentSlotId: data.appointmentSlotId,
      reason: data.reason,
      action: "CANCELLED",
    }
  );
};

export const apiMouqabalaCancelInfos = (data: {
  appointmentRequestId: string;
}): Promise<AxiosResponse<any, any>> => {
  return axios.get(
    MOUQABALA_BASE_URL +
      "/appointment-requests/" +
      data.appointmentRequestId +
      "/cancel-infos"
  );
};

export const apiMouqabalaAccept = (
  id_mouqabala: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    MOUQABALA_BASE_URL + "/appointment-requests/" + id_mouqabala + "/decision",
    {
      isAccepted: true,
    }
  );
};

export const apiMouqabalaDeny = (
  id_mouqabala: string
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    MOUQABALA_BASE_URL + "/appointment-requests/" + id_mouqabala + "/decision",
    {
      isAccepted: false,
    }
  );
};

export const apiGetMouqabalaInfos = (): Promise<AxiosResponse<any, any>> => {
  return axios.get(
    MOUQABALA_BASE_URL +
      "/appointment-requests?page=" +
      1 +
      "&limit=" +
      1 +
      "&statut=PENDING"
  );
};

export const apiGetReminder = (): Promise<AxiosResponse<any, any>> => {
  return axios.get(MOUQABALA_BASE_URL + "/reminder");
};
